import { isTransitionalPeriodActive, ADDRESS_POST_CODE_MAX_LENGTH } from 'shared/ncts/common/constants'

const E1102Validator = {
  getPostcodeMaxLength: () => (isTransitionalPeriodActive() ? 9 : ADDRESS_POST_CODE_MAX_LENGTH),
} as const

export default E1102Validator
